
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/presale",
      function () {
        return require("private-next-pages/presale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/presale"])
      });
    }
  